"use client";

import { Link } from "@/components/Actions";
import { PageSection } from "@/components/Coop/PageSection";
import { useUser } from "@/hooks/useUser";
import { useRouter } from "next/navigation";
import { useEffect } from "react";

export default function CoopRoot() {
  const { user } = useUser();
  const { push } = useRouter();

  useEffect(() => {
    if (user) {
      push("/coop/profile");
    }
  }, [user, push]);

  return (
    <PageSection>
      <h3 className="display2 mb-6 text-center text-balance italic">
        Welcome to the Coinage Coop
      </h3>
      {!user ? (
        <p className="body1 block">Connect your wallet to get started</p>
      ) : (
        <Link modifier="secondary" href="/coop/profile">
          Go to profile
        </Link>
      )}
    </PageSection>
  );
}
